import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
// rxjs
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
// services
import { EventsService } from '../../booking/services/events.service';
import { ApplicationInsightsService } from '../../shared/services/app-insights.service';
import { AppLoaderService } from './app-loader.service';
import { AppState } from 'app/booking/models/app-state.interface';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
// import globals
import { GET_ERROR_COPY_DATA } from '../globals';
declare var ga: any;

@Injectable({
  providedIn: 'root',
})
export class ErrorHandler {

  private _notificationData = {
    title: '',
    text: '',
    type: 'danger',
    icon: 'alert',
    sticky: false
  };
  private _messageTextHolder;

  public notificationItem$: Subject<any> = new Subject();
  public modalItem$: Subject<any> = new Subject();
  public bookingPromoError$: Subject<any> = new Subject();
  public removeBookingReference$: Subject<any> = new Subject();
  public removeD2dService$: Subject<boolean> = new Subject();
  public removeFlightData$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public createNewBookingReference$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private copyResponseData

  constructor(
    private _eventsService: EventsService,
    private _http: HttpClient,
    private _router: Router,
    private _appLoaderService: AppLoaderService,
    private _insightsService: ApplicationInsightsService,
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.getStaticCopy();
   }

  getStaticCopy(error?:any) {
    this._http.get(GET_ERROR_COPY_DATA)
      .subscribe((res: any) => {
        console.log(res);
        this.copyResponseData = res;
        if (error){this.checkResponseCodes(error);}
      },
      (err) => {
        if (error) {
          this.checkResponseCodes(error);
        }
      }
    );
  }

  getTranslationByKey(key) {
    if (!this.copyResponseData) {
      return key;
    }

    const appState = this.getState(this._appStore);
    const selectedLanguage = appState.copyReducer.language || '';
    const lookupKey = key + selectedLanguage;

    return this.copyResponseData[lookupKey] ?? this.copyResponseData[key] ?? key;
  }

  handleError(error: any) {
    this._appLoaderService.hideLoader();
    this.getStaticCopy(error);
    this._insightsService.trackException(error);
    this._appStore.dispatch({ type: 'UPDATE_FLYBACK_REDIRECT', payload: true });
  }

  handleCustomError(error: any, replace?: boolean, params?: any) {
    const appState = this.getState(this._appStore);
    const selectedLanguage = appState.copyReducer.language;

    if (replace) {
      if (this.copyResponseData[error.text+selectedLanguage]) {
        error.text = this.copyResponseData[error.text+selectedLanguage]
      }
      // iterate through parms
      if (Array.isArray(params)) {
        for (const param of params) {
          error.text = error.text.replace('%s', param)
        }
      }
    }

    this._notificationData = {
      title: '',
      text: this.copyResponseData[error.text+selectedLanguage] ? this.copyResponseData[error.text+selectedLanguage] : error.text,
      type: 'danger',
      icon: 'alert',
      sticky: error.sticky
    };
    this.notificationItem$.next(this._notificationData);
    this.sendGAData(this._notificationData);
  }

  handleCustomInfo(info: any, replaceTitle?: boolean, param?: any) {
    info.title = info.title ? this.getTranslationByKey(info.title) : info.title;
    info.text = info.text ? this.getTranslationByKey(info.text) : info.text;

    if (replaceTitle && info.title) {
      info.title = info.title.replace("%s", param);
    }

    if (replaceTitle && info.title) {
      info.title = info.title.replace("%s", param);
    }

    this._notificationData = {
      title: info.title,
      text: info.text,
      type: info.type,
      icon: info.icon,
      sticky: info.sticky
    };

    this.notificationItem$.next(this._notificationData);
    this.sendGAData(this._notificationData);
  }

  handleCustomMessage(message: any) {

    this._notificationData.text = message.text;
    this._notificationData.type = message.type;
    this.notificationItem$.next(this._notificationData);
  }

  handleModal(message: any) {
    this.modalItem$.next(message);
  }

  removeModal() {
    this.modalItem$.next('remove');
  }

  checkResponseCodes(err: any) {
    const appState = this.getState(this._appStore);
    const bookingProductType = appState.bookingReducer.bookingDetails.bookingProduct;
    const selectedLanguage = appState.copyReducer.language;
    const penalType = bookingProductType === 'abc' ? 'collection' : 'delivery'

    this._messageTextHolder = '';

    if (err.status === 401) {

      // catch errors 401 (Unauthorized)
      this._notificationData.text = this.copyResponseData['There has been an issue with your credentials, please log in.'+selectedLanguage] ?? 'There has been an issue with your credentials, please log in.';
      this.notificationItem$.next(this._notificationData);
      this.sendGAData(this._notificationData);
      setTimeout(() => {
        this._router.navigate(['login']);
      }, 5000);

    } else if (err.status >= 400 && err.status < 500) {

      // catch errors from bad request (400), not 401 and not including 500
      let errJson = null;
      try {
        errJson = err.error;
      } catch (cErr) {
        errJson = JSON.parse(err);
      }

      if (errJson.validationErrorMessages && typeof errJson.validationErrorMessages !== 'undefined' && typeof errJson.translationResponse !== 'undefined') {

        const sectionCode = [];
        for (const item of errJson.validationErrorMessages) {

          const sectionReason = item.reasons;
          sectionCode.push(item.code);

          for (const reason of sectionReason) {
            this._messageTextHolder += reason + '<br>';
          }

        }
        if (errJson.translationResponse.translationValidationErrors.length > 0) {
          this._messageTextHolder = '';
        }
        sectionCode.push(errJson.translationResponse.code)
        for (const err of errJson.translationResponse.translationValidationErrors) {
          this._messageTextHolder += this.copyResponseData ? this.copyResponseData[err.errorMessage+selectedLanguage] ? this.copyResponseData[err.errorMessage+selectedLanguage] : err.errorMessage : err.errorMessage + '<br>';
          const changeAbles = Object.keys(err.parameters);
          if (changeAbles.length > 0) {
            for (const params of changeAbles) {
              const text = '{'+params+'}';

              const params_text = err.parameters[params] && this.copyResponseData[err.parameters[params]+selectedLanguage]  ? this.copyResponseData[err.parameters[params]+selectedLanguage] : err.parameters[params];

              this._messageTextHolder = this._messageTextHolder.replace(text, params_text)
            }
          }
        }
        // check custom error codes sent
        // handle as required

        if (typeof this._messageTextHolder === 'undefined' || this._messageTextHolder === '') {
          this._notificationData.text = this.copyResponseData['There seems to have been an issue. If the problem persists please email:'+selectedLanguage]
            ?? 'There seems to have been an issue. If the problem persists please email:' +
            ' <a href="mailto:support@portr.com">support@portr.com</a>';
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
        }

        // payment error
        if (sectionCode.some(x => x === 900)) {
          this._notificationData.text = this._messageTextHolder;
          this._notificationData.sticky = true;
          this.notificationItem$.next(this._notificationData);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
        }
        // payment error
        if (sectionCode.some(x => x === 920)) {
          this._notificationData.text = this._messageTextHolder;
          // console.log('promo', this._notificationData);
          this.notificationItem$.next(this._notificationData);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
        }
        // payment error
        if (sectionCode.some(x => x === 930)) {
          this._notificationData.text =
            this.copyResponseData['There seems to have been an error with your payment details. Please try entering again including any promo code.' + selectedLanguage]
              ?? 'There seems to have been an error with your payment details. Please try entering again including any promo code.';
          this.notificationItem$.next(this._notificationData);
          this.bookingPromoError$.next(true);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
        }
        // reset password link expired OR flight cache data
        if (sectionCode.some(x => x === 600)) {
          this._notificationData.text = this._messageTextHolder;
          // console.log('flight', this._notificationData);
          this._appLoaderService.hideLoader();
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
        }
        // SMS code validation error
        if (sectionCode.some(x => x === 717)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
        }
        // magic link validation error
        if (sectionCode.some(x => x === 718)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          console.log(this._notificationData.text);
          this.sendGAData(this._notificationData);
        }
        // timeslot error
        if (sectionCode.some(x => x === 760)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
          this._appLoaderService.hideLoader();
          // check product type
          setTimeout(() => {
            this._eventsService.goToPanelByPath(penalType + '-time');
          }, 5000);
        }
        // timeslot error
        if (sectionCode.some(x => x === 761)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.removeFlightData$.next(true);
          this.sendGAData(this._notificationData);
          this._appLoaderService.hideLoader();
          setTimeout(() => {
            this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          }, 3500);
        }
        // timeslot error - no timeslots
        if (sectionCode.some(x => x === 762)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          }, 3500);
        }
        // timeslot error - LCY weekends
        if (sectionCode.some(x => x === 763)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.removeFlightData$.next(true);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          }, 5000);
        }
        // timeslot error - public holiday
        if (sectionCode.some(x => x === 764)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.removeFlightData$.next(true);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          }, 5000);
        }
        // timeslot error - abc/sds timeslot check
        if (sectionCode.some(x => x === 765)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.removeFlightData$.next(true);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          }, 5000);
        }
        // location error
        if (sectionCode.some(x => x === 870)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
          this._appLoaderService.hideLoader();
          // check product type
          setTimeout(() => {
            this._eventsService.goToPanelByPath(penalType + '-location');
          }, 5000);
        }
        // location outside service area
        if (sectionCode.some(x => x === 940)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
          // check product type
          setTimeout(() => {
            this._eventsService.goToPanelByPath(penalType + '-location');
          }, 5000);
        }
        // bags error
        if (sectionCode.some(x => x === 840)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._eventsService.goToPanelByPath('bags');
          }, 3500);
        }
        // Auth errors
        // booking referenece not assigned to userid
        if (sectionCode.some(x => x === 730)) {
          // this._notificationData.text = this._messageTextHolder;
          // this.notificationItem$.next(this._notificationData);
          this.removeBookingReference$.next(true);
        }
        // reset password link expired
        if (sectionCode.some(x => x === 715)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._router.navigate(['access-options']);
          }, 5000);
        }
        // reset password link expired
        if (sectionCode.some(x => x === 716)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
        }
        // duplicate booking reference - booking already exists
        if (sectionCode.some(x => x === 780)) {
          // this._notificationData.text = this._messageTextHolder;
          // this.notificationItem$.next(this._notificationData);
          this.createNewBookingReference$.next(true);
          this.sendGAData(this._notificationData);
          // setTimeout(() => {
          //   this._router.navigate(['login']);
          // }, 5000);
        }
        if (sectionCode.some(x => x === 950)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._router.navigate(['login']);
          }, 5000);
        }
        // booking deatils booking reference error
        if (sectionCode.some(x => x === 795)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
          setTimeout(() => {
            this._router.navigate(['login']);
          }, 5000);
        }
        // booking deatils booking reference error
        if (sectionCode.some(x => x === 790)) {
          this._notificationData.text = this._messageTextHolder;
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
          this._appLoaderService.hideLoader();
          setTimeout(() => {
            this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          }, 5000);
        }
        // Track booking errors
        // if (sectionCode.some(x => x === 730)) {
        //   this._notificationData.text = this._messageTextHolder;
        //   this.notificationItem$.next(this._notificationData);
        //   setTimeout(() => {
        //     this._router.navigate(['login']);
        //   }, 5000);
        // }

      } else if (typeof errJson.validationErrors !== 'undefined' && typeof errJson.translationResponse !== 'undefined' && errJson.translationResponse.translationValidationErrors.length > 0) {


        if (errJson.translationResponse.translationValidationErrors.length > 0) {
          this._messageTextHolder = '';
        }

        for (const err of errJson.translationResponse.translationValidationErrors) {
          this._messageTextHolder += this.copyResponseData ? this.copyResponseData[err.errorMessage+selectedLanguage] ? this.copyResponseData[err.errorMessage+selectedLanguage] : err.errorMessage : err.errorMessage + '<br>';
          const changeAbles = Object.keys(err.parameters);
          if (changeAbles.length > 0) {
            for (const params of changeAbles) {
              const text = '{'+params+'}';

              const params_text = err.parameters[params] && this.copyResponseData[err.parameters[params]+selectedLanguage]  ? this.copyResponseData[err.parameters[params]+selectedLanguage] : err.parameters[params];

              this._messageTextHolder = this._messageTextHolder.replace(text, params_text)
            }
          }
        }

        this._notificationData.text = this._messageTextHolder;

        this.notificationItem$.next(this._notificationData);
        this.sendGAData(this._notificationData);

      } else if (typeof errJson.modelState !== 'undefined') {
        // handle model validation Messages
        const model = errJson.modelState,
          modelCode = [],
          modelText = [];

        for (let h = 0; h < Object.keys(model).length; h++) {
          const prop = model[Object.keys(model)[h]];
          // split string on :
          const code = prop[0].split(':');
          // parse and push into array
          modelCode.push(parseInt(code[0], 10));
          modelText.push(code[1]);
        }

        if (typeof modelText[0] === 'undefined') {

          this._notificationData.text = this.copyResponseData['There seems to have been an issue. If the problem persists please email:' + selectedLanguage]
            ?? 'There seems to have been an issue. If the problem persists please email:' +
            ' <a href="mailto:support@portr.com">support@portr.com</a>';
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
        }

        // flight details request errors
        if (modelCode.some(x => x === 600)) {

          this._notificationData.text = modelText[0];
          this.notificationItem$.next(this._notificationData);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
        }
        // flight product error
        if (modelCode.some(x => x === 601)) {
          this._notificationData.text = modelText[0];
          this.notificationItem$.next(this._notificationData);
          this._appLoaderService.hideLoader();
          this.sendGAData(this._notificationData);
        }
        // reset password link expired
        if (modelCode.some(x => x === 715)) {
          this._notificationData.text = modelText[0];
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
        }
        // passenger details
        if (modelCode.some(x => x === 860)) {
          this._notificationData.text = modelText[0];
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
        }
        // location error
        if (modelCode.some(x => x === 870)) {
          this._notificationData.text = modelText[0];
          this.notificationItem$.next(this._notificationData);
          this.sendGAData(this._notificationData);
          // check product type
          setTimeout(() => {
            this._eventsService.goToPanelByPath(penalType + '-location');
          }, 5000);
        }

      } else if (typeof errJson.error_description !== 'undefined') {
        errJson.error_description = this.copyResponseData[errJson.error_description + selectedLanguage]
          ? this.copyResponseData[errJson.error_description + selectedLanguage]
          : errJson.error_description;
        this._notificationData.text = errJson.error_description;
        this.notificationItem$.next(this._notificationData);
        this.sendGAData(this._notificationData);
      } else if (typeof errJson.validationErrors !== 'undefined') {
        for (const item of errJson.validationErrors) {
          this._messageTextHolder = item;
        }
        this._notificationData.text = this._messageTextHolder;
        this.notificationItem$.next(this._notificationData);
        this.sendGAData(this._notificationData);
      } else {
        this._notificationData.text = this.copyResponseData['There seems to have been an issue. If the problem persists please email:' + selectedLanguage]
        ?? 'There seems to have been an issue. If the problem persists please email:' +
          ' <a href="mailto:support@portr.com">support@portr.com</a>';
        this.notificationItem$.next(this._notificationData);
        this.sendGAData(this._notificationData);
      }

    } else if (err.status >= 500) {
      // console.log('REDIRECT');
      // this._notificationData.text = '500 ERROR';
      // this.notificationItem$.next(this._notificationData);
      this._notificationData.text = '500 error';
      this.sendGAData(this._notificationData);
      this._router.navigate(['error-500']);
    }
  }

  sendGAData(d) {
    if (isPlatformBrowser(this.platformId)) {
      const currentUrl = location.pathname;
      ga('send', 'event', 'Error', d.text, currentUrl);
    }
  }

  getStaticCopyHtml(error?: any): Promise<string> {
    return new Promise((resolve, reject) => {
      this._http.get(GET_ERROR_COPY_DATA)
        .subscribe((res: any) => {
          console.log(res);
          this.copyResponseData = res;
          if (error) {
            const html = this.checkResponseCodesHtml(error);
            resolve(html);
          } else {
            resolve('');
          }
        },
          err => {
            if (error) {
              const html = this.checkResponseCodesHtml(error);
              resolve(html);
            } else {
              resolve('');
            }
          });
    });
  }

  checkResponseCodesHtml(err: any): string {
    const appState = this.getState(this._appStore);
    const bookingProductType = appState.bookingReducer.bookingDetails.bookingProduct;
    const selectedLanguage = appState.copyReducer.language;
    const penalType = bookingProductType === 'abc' ? 'collection' : 'delivery'

    this._messageTextHolder = '';

    if (err.status === 401) {

      // catch errors 401 (Unauthorized)
      const text = this.copyResponseData['There has been an issue with your credentials, please log in.' + selectedLanguage] ?? 'There has been an issue with your credentials, please log in.';
      return text;

    } else if (err.status >= 400 && err.status < 500) {

      // catch errors from bad request (400), not 401 and not including 500
      let errJson = null;
      try {
        errJson = err.error;
      } catch (cErr) {
        errJson = JSON.parse(err);
      }

      if (errJson.validationErrorMessages && typeof errJson.validationErrorMessages !== 'undefined' && typeof errJson.translationResponse !== 'undefined') {

        const sectionCode = [];
        for (const item of errJson.validationErrorMessages) {

          const sectionReason = item.reasons;
          sectionCode.push(item.code);

          for (const reason of sectionReason) {
            this._messageTextHolder += reason + '<br>';
          }

        }
        if (errJson.translationResponse.translationValidationErrors.length > 0) {
          this._messageTextHolder = '';
        }
        sectionCode.push(errJson.translationResponse.code)
        for (const err of errJson.translationResponse.translationValidationErrors) {
          this._messageTextHolder += this.copyResponseData ? this.copyResponseData[err.errorMessage + selectedLanguage] ? this.copyResponseData[err.errorMessage + selectedLanguage] : err.errorMessage : err.errorMessage + '<br>';
          const changeAbles = Object.keys(err.parameters);
          if (changeAbles.length > 0) {
            for (const params of changeAbles) {
              const text = '{' + params + '}';

              const params_text = err.parameters[params] && this.copyResponseData[err.parameters[params] + selectedLanguage] ? this.copyResponseData[err.parameters[params] + selectedLanguage] : err.parameters[params];

              this._messageTextHolder = this._messageTextHolder.replace(text, params_text)
            }
          }
        }
        // check custom error codes sent
        // handle as required

        if (typeof this._messageTextHolder === 'undefined' || this._messageTextHolder === '') {
          const text = this.copyResponseData['There seems to have been an issue. If the problem persists please email:' + selectedLanguage]
            ?? 'There seems to have been an issue. If the problem persists please email:' +
            ' <a href="mailto:support@portr.com">support@portr.com</a>';
          return text;
        }

        // payment error
        if (sectionCode.some(x => x === 900)) {
          return this._messageTextHolder;
        }
        // payment error
        if (sectionCode.some(x => x === 920)) {
          return this._messageTextHolder;
        }
        // payment error
        if (sectionCode.some(x => x === 930)) {
          const text =
            this.copyResponseData['There seems to have been an error with your payment details. Please try entering again including any promo code.' + selectedLanguage]
            ?? 'There seems to have been an error with your payment details. Please try entering again including any promo code.';
          return text;
        }
        // reset password link expired OR flight cache data
        if (sectionCode.some(x => x === 600)) {
          return this._messageTextHolder;
        }
        // SMS code validation error
        if (sectionCode.some(x => x === 717)) {
          return this._messageTextHolder;
        }
        // magic link validation error
        if (sectionCode.some(x => x === 718)) {
          return this._messageTextHolder;
        }

        // timeslot error
        if (sectionCode.some(x => x === 760)) {
          return this.handleTimeslotErrorsHtml(err.api);
        }
        // timeslot error
        if (sectionCode.some(x => x === 761)) {
          return this.handleTimeslotErrorsHtml(err.api);
        }
        // timeslot error - no timeslots
        if (sectionCode.some(x => x === 762)) {
          return this.handleTimeslotErrorsHtml(err.api);
        }
        // timeslot error - LCY weekends
        if (sectionCode.some(x => x === 763)) {
          return this.handleTimeslotErrorsHtml(err.api);
        }
        // timeslot error - public holiday
        if (sectionCode.some(x => x === 764)) {
          return this.handleTimeslotErrorsHtml(err.api);
        }
        // timeslot error - abc/sds timeslot check
        if (sectionCode.some(x => x === 765)) {
          return this.handleTimeslotErrorsHtml(err.api);
        }
        // location error
        if (sectionCode.some(x => x === 870)) {
          return this._messageTextHolder;
        }
        // location outside service area
        if (sectionCode.some(x => x === 940)) {
          return this._messageTextHolder;
        }
        // bags error
        if (sectionCode.some(x => x === 840)) {
          return this._messageTextHolder;
        }
        // Auth errors
        // booking referenece not assigned to userid
        if (sectionCode.some(x => x === 730)) {
          return this._messageTextHolder;
        }
        // reset password link expired
        if (sectionCode.some(x => x === 715)) {
          return this._messageTextHolder;
        }
        // reset password link expired
        if (sectionCode.some(x => x === 716)) {
          return this._messageTextHolder;
        }
        // duplicate booking reference - booking already exists
        if (sectionCode.some(x => x === 780)) {
          return this._messageTextHolder;
        }
        if (sectionCode.some(x => x === 950)) {
          return this._messageTextHolder;
        }
        // booking deatils booking reference error
        if (sectionCode.some(x => x === 795)) {
          return this._messageTextHolder;
        }
        // booking deatils booking reference error
        if (sectionCode.some(x => x === 790)) {
          return this._messageTextHolder;
        }
        // Track booking errors
        // if (sectionCode.some(x => x === 730)) {
        //   this._notificationData.text = this._messageTextHolder;
        //   this.notificationItem$.next(this._notificationData);
        //   setTimeout(() => {
        //     this._router.navigate(['login']);
        //   }, 5000);
        // }

      } else if (typeof errJson.validationErrors !== 'undefined' && typeof errJson.translationResponse !== 'undefined' && errJson.translationResponse.translationValidationErrors.length > 0) {


        if (errJson.translationResponse.translationValidationErrors.length > 0) {
          this._messageTextHolder = '';
        }

        for (const err of errJson.translationResponse.translationValidationErrors) {
          this._messageTextHolder += this.copyResponseData ? this.copyResponseData[err.errorMessage + selectedLanguage] ? this.copyResponseData[err.errorMessage + selectedLanguage] : err.errorMessage : err.errorMessage + '<br>';
          const changeAbles = Object.keys(err.parameters);
          if (changeAbles.length > 0) {
            for (const params of changeAbles) {
              const text = '{' + params + '}';

              const params_text = err.parameters[params] && this.copyResponseData[err.parameters[params] + selectedLanguage] ? this.copyResponseData[err.parameters[params] + selectedLanguage] : err.parameters[params];

              this._messageTextHolder = this._messageTextHolder.replace(text, params_text)
            }
          }
        }

        return this._messageTextHolder;

      } else if (typeof errJson.modelState !== 'undefined') {
        // handle model validation Messages
        const model = errJson.modelState,
          modelCode = [],
          modelText = [];

        for (let h = 0; h < Object.keys(model).length; h++) {
          const prop = model[Object.keys(model)[h]];
          // split string on :
          const code = prop[0].split(':');
          // parse and push into array
          modelCode.push(parseInt(code[0], 10));
          modelText.push(code[1]);
        }

        if (typeof modelText[0] === 'undefined') {

          const text = this.copyResponseData['There seems to have been an issue. If the problem persists please email:' + selectedLanguage]
            ?? 'There seems to have been an issue. If the problem persists please email:' +
            ' <a href="mailto:support@portr.com">support@portr.com</a>';
          return text;
        }

        // flight details request errors
        if (modelCode.some(x => x === 600)) {

          return modelText[0];
        }
        // flight product error
        if (modelCode.some(x => x === 601)) {
          return modelText[0];
        }
        // reset password link expired
        if (modelCode.some(x => x === 715)) {
          return modelText[0];
        }
        // passenger details
        if (modelCode.some(x => x === 860)) {
          return modelText[0];
        }
        // location error
        if (modelCode.some(x => x === 870)) {
          return modelText[0];
        }

      } else if (typeof errJson.error_description !== 'undefined') {
        errJson.error_description = this.copyResponseData[errJson.error_description + selectedLanguage]
          ? this.copyResponseData[errJson.error_description + selectedLanguage]
          : errJson.error_description;
        return errJson.error_description;
      } else if (typeof errJson.validationErrors !== 'undefined') {
        for (const item of errJson.validationErrors) {
          this._messageTextHolder = item;
        }
        return this._messageTextHolder;
      } else {
        const text = this.copyResponseData['There seems to have been an issue. If the problem persists please email:' + selectedLanguage]
          ?? 'There seems to have been an issue. If the problem persists please email:' +
          ' <a href="mailto:support@portr.com">support@portr.com</a>';
        return text;
      }

    } else if (err.status >= 500) {
      return '500 error';
    }
    return '';
  }

  handleTimeslotErrorsHtml(api): string {
    return this._messageTextHolder;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe(s => state = s);
    return state;
  }
}
